import Vue from 'vue'
// import VueRouter from 'vue-state-router'
import VueRouter from 'vue-router'

import NotFound from "@/views/NotFound.vue"
const AdminView = () => import(/* webpackChunkName: "about" */ '@/views/AdminView.vue')

const AboutPage = () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
const AboutTerms = () => import(/* webpackChunkName: "about" */ "@/views/TermsOfService.vue")
const AboutFeedback = () => import(/* webpackChunkName: "about" */ "@/views/SendFeedback.vue")
const AboutUsage = () => import(/* webpackChunkName: "about" */ "@/views/UsageHelp.vue")

const ArticleView = () => import("@/views/ArticleView.vue")
const SearchView = () => import("@/views/SearchView")

const VaultsHome = () => import("@/views/VaultsHome.vue")
const JournalView = () => import("@/views/JournalView.vue")
const CollectionHome = () => import("@/views/CollectionHome.vue")

// import VaultsHome from "@/views/VaultsHome.vue"
// import JournalView from "@/views/JournalView.vue"
// import CollectionHome from "@/views/CollectionHome.vue"

Vue.use(VueRouter)

const CryptoJS = require('crypto-js')
import store from "@/store"
import {debug} from "@/api/logging"
import {
  get_login_by_user,
  generic_api,
  get_journal,
  get_journal_vols,
  get_indexed_artis,
} from "@/api"
const secretKey = 'udpes-20201124'

// const words = "chdvmm:chdvmm"
// const encoded_pwd = CryptoJS.AES.encrypt(words, secretKey).toString()
// debug('ecoded_pwd', encoded_pwd)
// const decoded_pwd = CryptoJS.AES.decrypt(encoded_pwd, secretKey).toString(CryptoJS.enc.Utf8)
// const [uid, pwd] = decoded_pwd.split(':')
// debug('decoded_pwd', decoded_pwd, uid, pwd)

const masonry_search_support = ['waa', 'wai', 'diw', 'art', 'lio', 'lip', 'dit', 'dic', 'dif']
// DONE dit 目前的圖片是 arti-api parse content 後產生的，要移到 toml -> es 階段，讓程式碼正規化，再加入 masonry 支援

function props_from_query(route)
{
  const {layout='def'} = route.query
  const {batch=20, fromYear, fromMonth, toYear, toMonth, sort} = route.query
  let {setsn} = route.query
  try {
    setsn = setsn.split(',').filter(function(i){return i})
  }
  catch {
    setsn = undefined
  }
  let {fields} = route.query
  try {
    fields = fields.split(',').filter(function(i){return i})
  }
  catch {
    fields = undefined
  }
  const q = {fromYear, fromMonth, toYear, toMonth, batch}
  for(let k in q) {
    const v = Number(q[k])
    if(Number.isNaN(v)) {
      delete q[k]
    }
    else {
      q[k] = v
    }
  }
  const props = Object.assign({}, {layout, setsn, fields, sort}, q)
  debug('props', props)
  return props
}

const routes1 = [
  {
    path: '/login/:encoded_pwd?',
    name: 'LoginRedirector',
    beforeEnter(to, from, next) {
      const {encoded_pwd} = to.params
      if(encoded_pwd) {
        // debug('encoded_pwd', encoded_pwd)
        const decoded_pwd = CryptoJS.AES.decrypt(encoded_pwd, secretKey).toString(CryptoJS.enc.Utf8)
        // debug('decoded_pwd', decoded_pwd)
        const [uid, pwd] = decoded_pwd.split(':')
        get_login_by_user(uid, pwd).finally(()=>{
          next('/')
        })
      }
      else {
        next('/')
      }
    },
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminView,
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage,
  },
  {
    path: '/about/terms',
    name: 'AboutTerms',
    component: AboutTerms,
  },
  {
    path: '/about/feedback',
    name: 'AboutFeedback',
    component: AboutFeedback,
  },
  {
    path: '/about/tutorial',
    name: 'AboutUsage',
    component: AboutUsage,
  },
  {
    path: '/',
    name: 'VaultsHome',
    component: VaultsHome,
  },
  {
    path: '/q/:q?',
    name: 'VaultsSearch',
    component: SearchView,
    // props: true,
    props: (route)=>{
      const {q} = route.params
      const query = props_from_query(route)
      return Object.assign({}, {q}, query)
    }
  },
  {
    path: '/:uniname?/view/:metaNo/:layout?',
    name: 'ArtiView',
    component: ArticleView,
    props: route => Object.assign({}, route.query, route.params),
    beforeEnter(to, from, next) {
      const {uniname, metaNo} = to.params
      if(uniname != metaNo.slice(0, 3)) {
        const params = Object.assign({}, to.params, {uniname: metaNo.slice(0, 3)})
        const query = Object.assign({}, to.query)
        next({name: 'ArtiView', params, query})
      }
      else {
        next()
      }
    },
  },
  {
    path: '/view/:metaNo',
    name: 'ArticleView',
    redirect: to => {
      const {metaNo} = to.params
      return {
        name: 'ArtiView',
        params: {
          uniname: metaNo.slice(0, 3),
          metaNo,
        },
      }
    },
  },
  {
    path: '/:uniname',
    name: 'JournalHome',
    component: JournalView,
    props: true,
    beforeEnter(to, from, next) {
      next()
      // const {uniname} = to.params
      // debug('beforeEnter', to, from)
      // return get_indexed_artis(uniname, {}).then((resp)=>{
      //   resp.uniname = uniname
      //   to.params.preloaded_artis = resp
      //   next()
      // })
    },
  },
  {
    path: '/:uniname/i/:idx/:ikey?/:imetano?',
    name: 'JournalIdx',
    component: JournalView,
    props: true,
    beforeEnter(to, from, next) {
      next()
      // const {uniname} = to.params
      // debug('beforeEnter', to, from)
      // return get_indexed_artis(uniname, {}).then((resp)=>{
      //   resp.uniname = uniname
      //   to.params.preloaded_artis = resp
      //   next()
      // })
    },
  },
  {
    path: '/:uniname/q/:q?',
    name: 'JournalSearch',
    component: SearchView,
    props: (route)=>{
      const {uniname, q} = route.params
      const query = props_from_query(route)
      if(query.layout == 'def' && masonry_search_support.includes(uniname)) {
        query.layout = 'masonry'
      }
      return Object.assign({}, {uniname, q}, query)
    }
  },
  {
    path: '/:mainset_id/q/:q?',
    name: 'CollectionSearch',
    component: SearchView,
    // props: true,
    props: (route)=>{
      // debug('route::CollectionSearch')
      const {mainset_id, q} = route.params
      const query = props_from_query(route)
      if(query.layout == 'def' && masonry_search_support.includes(mainset_id)) {
        query.layout = 'masonry'
      }
      return Object.assign({}, {mainset_id, q}, query)
    }
  },
  {
    path: '/:mainset_id',
    name: 'CollectionHome',
    component: CollectionHome,
    // props: true,
    props: (route)=>{
      const {mainset_id, q, batch, layout} = route.params
      return {mainset_id, q, batch, layout}
    }
  },
  {
    path: '/:mainset_id/s/:subset?',
    name: 'CollectionHome2',
    component: CollectionHome,
    props: true,
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  },
]

debug('theme', store.state.theme, store.state.theme_name)
debug('mainset', store.state.mainset_id, store.state.mainset_name)
var rr = []
const collection_sets = ['soc', 'sin', 'cbs', 'tai', 'syu', 'npm', 'art', 'waa', 'tdm']  // except bio, mdn
if(store.state.theme == 'p') {
  const k = store.state.mainset_id
  if(collection_sets.includes(k)) {
    const d = {
      path: `/${k}`,
      alias: '/',
      redirect: {
        name: "CollectionHome",
        params: {
          mainset_id: k,
        },
      },
    }
    rr.push(d)
  }
  else {
    const d = {
      path: `/${k}`,
      alias: '/',
      redirect: {
        name: "JournalHome",
        params: {
          uniname: k,
        },
      },
    }
    rr.push(d)
  }
}
else if(store.state.theme == 'es') {
  collection_sets.forEach(k=>{
    const d = {
      path: `/${k}`,
      redirect: {
        name: "CollectionHome",
        params: {
          mainset_id: k,
        },
      },
    }
    if(k == store.state.mainset_id) {
      d['alias'] = '/'
    }
    rr.push(d)
    const dd = {
      path: `/${k}/q/:q?`,
      props: true,
      beforeEnter(to, from, next) {
        const {q} = to.params
        const params = {mainset_id: k, q}
        const query = to.query
        const to_ = {name: 'CollectionSearch', params, query}
        next(to_)
      },
    }
    rr.push(dd)
  })
}
const routes = rr.concat(routes1)
debug('routes', routes)

const router = new VueRouter({
  mode: 'history',
  routes,
})

import {get_login_by_ip} from '@/api'
import {getTokens, getIdentity} from '@/api/token'
function auth_if_none()
{
  const {access_token} = getTokens()
  debug('auth_if_none', access_token)
  if(!access_token) {
    return get_login_by_ip()
  }
  return Promise.resolve()
}

var first_time = true
router.beforeEach((to, from, next) => {
  if(first_time) {
    first_time = false
    const {test} = to.query
    if(test !== undefined) {
      store.commit('set_test', !!Number(test))
    }
    generic_api("/qq/pubyears").then((rs) => {
      const { pubyears } = rs;
      store.commit('set_pubyears', {pubyears})
      return auth_if_none().then(()=>{
        debug('Identity before first time route', getIdentity())
        next()
      })
    })
  }
  else {
    next()
  }
})

router.afterEach((to)=> {
  const {path, query} = to
  debug('afterEach', to)
  store.commit('to_path', {path, query})
})

export default router
